/* eslint no-unused-vars: "off" */
import React from 'react';
import styled from 'styled-components';
import { WarrantyDescription, ListWrapper, ListItem, Paragraph } from './CarvanaCareDetails.styles';
import { LinkWithNativeEvents } from '../link/link';

const StyledLinkWithNativeEvents = styled(LinkWithNativeEvents)`
  color: var(--cvna-color-blue-2);
  text-decoration: underline;
  &:hover {
    text-decoration: none;
    color: var(--cvna-color-blue-2);
  }
`;

export const CarvanaCareEssential = ({ deductible }: any) => (
  <>
    <WarrantyDescription>
      <Paragraph data-testid="carvana-care-essential-body-text">
        Basic mechanical coverage for core engine and transmission.
      </Paragraph>
      <ListWrapper>
        {deductible && (
          <ListItem data-testid="carvana-care-essential-body-list-item-1">
            ${deductible?.inNetwork} deductible at preferred facilities; ${deductible?.outOfNetwork} at non-preferred
            facilities.
          </ListItem>
        )}
        <ListItem data-testid="carvana-care-essential-body-list-item-2">
          For roadside assistance, call{' '}
          <StyledLinkWithNativeEvents
            href="tel:+1-888-300-8607"
            nativeEvent={{
              event: 'phone',
              payload: {
                phoneNumber: '+1-888-300-8607',
              },
            }}
          >
            1-888-300-8607
          </StyledLinkWithNativeEvents>
          .
        </ListItem>
      </ListWrapper>
    </WarrantyDescription>
  </>
);

export const CarvanaCarePlus = ({ deductible }: any) => (
  <>
    <WarrantyDescription>
      <Paragraph data-testid="carvana-care-plus-body-text">
        Comprehensive protection for front-to-back coverage.
      </Paragraph>
      <ListWrapper>
        {deductible && (
          <ListItem data-testid="carvana-care-plus-body-list-item-1">
            ${deductible?.inNetwork} deductible at preferred facilities; ${deductible?.outOfNetwork} at non-preferred
            facilities.
          </ListItem>
        )}
        <ListItem data-testid="carvana-care-plus-body-list-item-2">
          For roadside assistance, call{' '}
          <StyledLinkWithNativeEvents
            href="tel:+1-888-300-8607"
            nativeEvent={{
              event: 'phone',
              payload: {
                phoneNumber: '+1-888-300-8607',
              },
            }}
          >
            1-888-300-8607
          </StyledLinkWithNativeEvents>
          .
        </ListItem>
      </ListWrapper>
    </WarrantyDescription>
  </>
);

export const CarvanaCarePremier = ({ deductible }: any) => (
  <>
    <WarrantyDescription>
      <Paragraph data-testid="carvana-care-premier-body-text">
        Premium front-to-back coverage including minor cosmetic protection and more.
      </Paragraph>
      <ListWrapper>
        {deductible && (
          <ListItem data-testid="carvana-care-premier-body-list-item-1">
            ${deductible?.inNetwork} deductible at preferred facilities; ${deductible?.outOfNetwork} at non-preferred
            facilities.
          </ListItem>
        )}
        <ListItem data-testid="carvana-care-premier-body-list-item-2">
          For roadside assistance, call{' '}
          <StyledLinkWithNativeEvents
            href="tel:+1-888-300-8607"
            nativeEvent={{
              event: 'phone',
              payload: {
                phoneNumber: '+1-888-300-8607',
              },
            }}
          >
            1-888-300-8607
          </StyledLinkWithNativeEvents>
          .
        </ListItem>
      </ListWrapper>
    </WarrantyDescription>
  </>
);

export const CarvanaCareSubscription = ({ deductible }: any) => (
  <>
    <WarrantyDescription>
      <Paragraph data-testid="carvana-care-subscription-body-text">
        Comprehensive protection for front-to-back coverage.
      </Paragraph>
      <ListWrapper>
        {deductible && (
          <ListItem data-testid="carvana-care-subscription-body-list-item-1">
            ${deductible?.inNetwork} deductible at preferred facilities; ${deductible?.outOfNetwork} at non-preferred
            facilities.
          </ListItem>
        )}
        <ListItem data-testid="carvana-care-subscription-body-list-item-2">
          For roadside assistance, call{' '}
          <StyledLinkWithNativeEvents
            href="tel:+1-888-300-8607"
            nativeEvent={{
              event: 'phone',
              payload: {
                phoneNumber: '+1-888-300-8607',
              },
            }}
          >
            1-888-300-8607
          </StyledLinkWithNativeEvents>
          .
        </ListItem>
      </ListWrapper>
    </WarrantyDescription>
  </>
);
